import React, {useEffect, useState, useCallback} from 'react';
import {View, ScrollView, StyleSheet} from 'react-native';
import {Appbar, TextInput, Button, Snackbar} from 'react-native-paper';
import {useTranslation} from 'react-i18next';
import {useNavigation} from '@react-navigation/native';
import {useConfigStore} from '../../store/useConfigStore';
import {colors, spacing} from '../../theme';

const BillSettingsScreen = () => {
  const {t} = useTranslation();
  const navigation = useNavigation();
  const {fetchByType, getProperty, updateProperties, isLoading} = useConfigStore();

  const [termsHeader, setTermsHeader] = useState('');
  const [footer, setFooter] = useState('');
  const [termsContent, setTermsContent] = useState('');
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState('');

  useEffect(() => {
    fetchByType('BILL');
  }, [fetchByType]);

  useEffect(() => {
    setTermsHeader(getProperty('BILL', 'BILL_TERMS_HEADER'));
    setFooter(getProperty('BILL', 'BILL_FOOTER'));
    setTermsContent(getProperty('BILL', 'BILL_TERMS'));
  }, [getProperty, useConfigStore.getState().properties]);

  const handleSave = useCallback(async () => {
    setSaving(true);
    try {
      await updateProperties('BILL', [
        {code: 'BILL_TERMS_HEADER', name: 'Terms & Conditions Header', value: termsHeader},
        {code: 'BILL_FOOTER', name: 'Bill Footer', value: footer},
        {code: 'BILL_TERMS', name: 'Terms & Conditions', value: termsContent},
      ]);
      setSnackbar(t('bill.settingsSaved'));
    } catch (e) {
      setSnackbar(e.response?.data?.message || t('common.error'));
    } finally {
      setSaving(false);
    }
  }, [termsHeader, footer, termsContent, updateProperties, t]);

  return (
    <View style={styles.container}>
      <Appbar.Header style={styles.appbar} dark>
        <Appbar.BackAction onPress={() => navigation.goBack()} color={colors.white} />
        <Appbar.Content title={t('bill.settingsTitle')} titleStyle={styles.appbarTitle} />
      </Appbar.Header>

      <ScrollView style={styles.content}>
        <TextInput
          label={t('bill.termsHeader')}
          value={termsHeader}
          onChangeText={setTermsHeader}
          mode="outlined"
          style={styles.input}
        />

        <TextInput
          label={t('bill.termsContent')}
          value={termsContent}
          onChangeText={setTermsContent}
          mode="outlined"
          multiline
          numberOfLines={6}
          style={styles.input}
        />

        <TextInput
          label={t('bill.footer')}
          value={footer}
          onChangeText={setFooter}
          mode="outlined"
          style={styles.input}
        />

        <Button
          mode="contained"
          onPress={handleSave}
          loading={saving}
          disabled={saving || isLoading}
          style={styles.saveBtn}
          buttonColor={colors.primary}>
          {t('common.save')}
        </Button>
      </ScrollView>

      <Snackbar
        visible={!!snackbar}
        onDismiss={() => setSnackbar('')}
        duration={2000}>
        {snackbar}
      </Snackbar>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {flex: 1, backgroundColor: colors.background},
  appbar: {backgroundColor: colors.primary},
  appbarTitle: {color: colors.white},
  content: {padding: spacing.md},
  input: {marginBottom: spacing.md, backgroundColor: colors.surface},
  saveBtn: {marginTop: spacing.sm},
});

export default BillSettingsScreen;
